import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, ref, onMounted } from '@nuxtjs/composition-api';
import ResourcesListHorizontalSsr from '@/components/resource/ResourcesListHorizontalSsr.vue';
import ResourcesListHorizontalCsr from '@/components/resource/ResourcesListHorizontalCsr.vue';
import { PublicV1ResourceRequest } from '@/types/api';
import { useLocale } from '~/composables/useLocale';

interface Props {
  parent: string;
}
type Slider = {
  show?: boolean;
  title: string;
  subheading?: string;
  link: string;
  params: PublicV1ResourceRequest;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Sliders',
  props: {
    parent: null
  },
  setup(__props: any) {

const props = __props as {
  parent: string;
};

const { i18n } = useContext();
const locale = useLocale();
const region = ref(i18n ? i18n.t('name') : null);



const translations = {
  maths: {
    au: { slug: 'maths', title: 'Maths' },
    gb: { slug: 'maths-gb', title: 'Maths' },
    us: { slug: 'mathematics-us', title: 'Math' },
  },
  english: {
    au: { slug: 'english', title: 'English' },
    gb: { slug: 'english-gb', title: 'English' },
    us: { slug: 'elar-us', title: 'English Language Arts' },
  },
  science: {
    au: { slug: 'science', title: 'Science' },
    gb: { slug: 'science-gb', title: 'Science' },
    us: { slug: 'science-us', title: 'Science' },
  },
};

// build the list of sliders
const sliders: Record<string, Slider> = {
  trending: {
    title: 'Trending',
    subheading: `The most popular resources in ${region.value} this week`,
    link: '/search/?sort=relevance',
    params: {
      country: locale.value,
      orderBy: 'popularity_1_week',
      direction: 'desc',
      payload: 'basic',
      perPage: 10,
    },
  },
  new: {
    title: 'New',
    link: '/search/?sort=recent',
    params: {
      country: locale.value,
      orderBy: 'modified',
      direction: 'desc',
      payload: 'basic',
      perPage: 10,
    },
  },
  tips: {
    title: 'Tips',
    link: '/search/?filter-format[0]=Podcast&filter-format[1]=Blog',
    params: {
      country: locale.value,
      types: ['blog'],
      orderBy: 'modified',
      direction: 'desc',
      payload: 'basic',
      perPage: 10,
    },
  },
  tools: {
    title: 'Tools',
    link: '/search/?sort=relevance&filter-format[0]=Widget',
    params: {
      country: locale.value,
      types: ['widget'],
      orderBy: 'popularity_1_week',
      direction: 'desc',
      payload: 'basic',
      perPage: 10,
    },
  },
  popular: {
    title: 'Popular',
    subheading: `The most popular resources in ${region.value} this month`,
    link: '/search/?sort=popularity',
    params: {
      country: locale.value,
      orderBy: 'popularity_1_month',
      direction: 'desc',
      payload: 'basic',
      excluded_categories: ['free'],
      perPage: 10,
    },
  },
  unit_lesson_plans: {
    show: locale.value === 'au',
    title: 'Unit & Lesson Plans',
    link: '/search/?filter-resource-type.lvl0[0]=Unit Plan&filter-resource-type.lvl0[1]=Lesson Plan&sort=relevance',
    params: {
      country: locale.value,
      types: ['unit-plan', 'lesson-plan'],
      orderBy: 'popularity_1_month',
      direction: 'desc',
      payload: 'basic',
      perPage: 10,
    },
  },
  maths: {
    title: translations.maths[locale.value].title,
    link: `/search/?filter-learning-area.lvl0[0]=${
      translations.maths[locale.value].title
    }&sort=relevance`,
    params: {
      country: locale.value,
      root: `learning-area-${locale.value}`,
      category: translations.maths[locale.value].slug,
      orderBy: 'popularity_1_week',
      direction: 'desc',
      payload: 'basic',
      perPage: 10,
    },
  },
  english: {
    title: translations.english[locale.value].title,
    link: `/search/?filter-learning-area.lvl0[0]=${
      translations.english[locale.value].title
    }&sort=relevance`,
    params: {
      country: locale.value,
      root: `learning-area-${locale.value}`,
      category: translations.english[locale.value].slug,
      orderBy: 'popularity_1_week',
      direction: 'desc',
      payload: 'basic',
      perPage: 10,
    },
  },
  science: {
    title: translations.science[locale.value].title,
    link: `/search/?filter-learning-area.lvl0[0]=${
      translations.science[locale.value].title
    }&sort=relevance`,
    params: {
      country: locale.value,
      root: `learning-area-${locale.value}`,
      category: translations.science[locale.value].slug,
      orderBy: 'popularity_1_week',
      direction: 'desc',
      payload: 'basic',
      perPage: 10,
    },
  },
};

const filteredSliders = computed(() =>
  Object.fromEntries(Object.entries(sliders).filter(([_, slider]) => slider.show !== false))
);

const firstSliders = computed(() =>
  Object.fromEntries(Object.entries(filteredSliders.value).slice(0, 3))
);
const lastSliders = computed(() =>
  Object.fromEntries(Object.entries(filteredSliders.value).slice(3))
);

const keys = Object.keys(filteredSliders.value);

return { __sfc: true,i18n, locale, region, props, translations, sliders, filteredSliders, firstSliders, lastSliders, keys, ResourcesListHorizontalSsr, ResourcesListHorizontalCsr }
}

})